// src/routes/ShopRoutes.jsx
import React from 'react';
import { Routes, Route } from 'react-router-dom';
import PermissionRoute from './PermissionRoute';

// Shop Management
import ShopsPage from '../pages/shops/ShopsPage';
import CreateShopPage from '../pages/shops/CreateShopPage';
import EditShopPage from '../pages/shops/EditShopPage';
import AssignProductsPage from '../pages/shops/AssignProductsPage';
import AssignUsersPage from '../pages/shops/AssignUsersPage';

const ShopRoutes = () => {
  return (
    <Routes>
      {/* Shop Management Routes */}
      <Route 
        path="/" 
        element={
            <PermissionRoute requiredPermission="view_all_shops">
              <ShopsPage />
            </PermissionRoute>
        } 
      />
      <Route 
        path="/create" 
        element={
            <PermissionRoute requiredPermission="create_shop">
              <CreateShopPage />
            </PermissionRoute>
        } 
      />
      <Route 
        path="/:shopId/edit" 
        element={
            <PermissionRoute requiredPermission="edit_shop">
              <EditShopPage />
            </PermissionRoute>
        } 
      />
      <Route
        path="/:shopId/assign-products"
        element={
          <PermissionRoute requiredPermission="assign_products_to_shop">
            <AssignProductsPage />
          </PermissionRoute>
        }
      />
      <Route
        path="/:shopId/assign-users"
        element={
          <PermissionRoute requiredPermission="assign_users_to_shop">
            <AssignUsersPage />
          </PermissionRoute>
        }
      />
    </Routes>
  );
};

export default ShopRoutes;